/**
 * Toggle Switch UI Component
 *
 * @example <sc-toggle-switch
 *              model="vm.model"
 *              left-val="vm.leftVal"
 *              right-val="vm.rightVal"
 *              left-label="{{vm.leftLabel"
 *              right-label="{{vm.rightLabel}}">
 *           </sc-toggle-switch>
 * @description Component of Sandcastle Framework. Inserts a toggle switch UI component.
 * @namespace Core
 * @memberof TR
 */

'use strict';

namespace Core {

    class ScToggleSwitch implements ng.IDirective {
        getRandomID;
        restrict: string;
        prefix: string;
        replace: boolean;
        transclude: boolean;
        scope: {};
        template;

        constructor() {
            this.restrict = 'E';
            this.replace = true;
            this.transclude = true;
            this.scope = {
                model : '=',
                leftVal : '=',
                rightVal : '=',
                leftLabel : '@',
                leftSubtext : '@',
                rightLabel : '@',
                rightSubtext : '@',
            };
            this.template =     `<form class="c-toggle-switch">
                                    <label
                                        class="c-toggle-switch__label"
                                        ng-class="{'c-toggle-switch__label--active': model === leftVal}"
                                        ng-mousedown="model = leftVal"
                                        aria-controls="{{componentId}}"
                                        aria-label="Toggle for {{leftLabel}}">
                                        {{leftLabel}}
                                        <sub class="c-toggle-switch__sublabel" ng-if="leftSubtext">
                                            {{leftSubtext}}
                                        </sub>
                                    </label>
                                    <div class="c-toggle-switch__container">
                                        <input
                                            id="{{componentId}}"
                                            class="c-toggle-switch__checkbox"
                                            type="checkbox"
                                            ng-class="class()"
                                            ng-click="toggle()"
                                            readonly>
                                        <span class="c-toggle-switch__handle" ng-click="toggle()"></span>
                                    </div>
                                    <label
                                        class="c-toggle-switch__label"
                                        ng-class="{'c-toggle-switch__label--active': model === rightVal}"
                                        ng-mousedown="model = rightVal"
                                        aria-controls="{{componentId}}"
                                        aria-label="Toggle for {{rightLabel}}">
                                        {{rightLabel}}
                                        <sub class="c-toggle-switch__sublabel" ng-if="rightSubtext">
                                            {{rightSubtext}}
                                        </sub>
                                    </label>
                                 </form>`;

            /**
             * Prefix for randomised ID on each directive

             * @private
             */
            this.prefix = 'c-number-picker--';

            /**
             * Generate random ID
             *
             * @param {string} prefix BEMIT formatted identifier. e.g. 'c-component--'
             * @returns {string} Prefix + Random string
             */
            this.getRandomID = (prefix) => {
                return prefix + Math.random().toString(36).substr(2, 7);
            };
        }

        link = (scope: ng.IScope) => {

            //Used to apply a unique id to the element for ARIA purposes
            scope.componentId = this.getRandomID(this.prefix);

            scope.class = function() {
                return scope.model === scope.rightVal ? 'c-toggle-switch__checkbox--on' : '';
            };

            scope.toggle = function() {
                scope.model = (scope.model === scope.leftVal ? scope.rightVal : scope.leftVal);
            };
        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new ScToggleSwitch();
            directive.$inject = [];
            return directive;
        }
    }

    const TR = angular.module('TR');
    TR.directive('scToggleSwitch', ScToggleSwitch.factory());

}
